export default __webpack_public_path__ + "0f380a01c8a4d4eac1338a3ecbbd6b15.svg";